import * as React from "react";
import { createFileRoute, notFound } from "@tanstack/react-router";

import { TagInput } from "@/components/tag-input";
import type { TagSummary } from "@/lib/tags";

/**
 * Development-only harness for the hashtag picker. The real picker lives behind
 * the authenticated editor, so end-to-end tests exercise its empty, error and
 * rate-limited states here. The route 404s outside development.
 */
export const Route = createFileRoute("/dev/tag-input")({
  beforeLoad: () => {
    if (!import.meta.env.DEV) throw notFound();
  },
  component: DevTagInputHarness,
  head: () => ({
    meta: [
      { title: "Hashtag picker harness · Quibblies" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});

function DevTagInputHarness() {
  const [tags, setTags] = React.useState<TagSummary[]>([]);
  return (
    <div className="mx-auto max-w-xl px-4 py-10">
      <h1 className="mb-6 text-xl font-semibold text-foreground">Hashtag picker harness</h1>
      <TagInput value={tags} onChange={setTags} />
    </div>
  );
}
